import React, { Component } from 'react';
import ArticlesItems from '../ArticlesItems/ArticlesItems';

//styles
import './SectionTen.scss';
class SectionTen extends Component {
    render() {
        return (
            <div id="section10" className="section10-container">
                <div className="line"></div>
                <div className="desc-container">
                    <div className="star"></div>
                    <div className="title">ארץ אחרת</div>
                    <div className="sub-title">אלכוהול, אינסטגרם ותפילות בעברית: איראן והחיים עצמם</div>
                    <ArticlesItems action="Article_Clicked" goToArticle={this.props.goToArticle} section={9} />
                </div>
            </div>
        );
    }
}

export default SectionTen;


// WEBPACK FOOTER //
// ./src/Components/SectionTen/SectionTen.js